import styles from './AnimationCube.module.css';

export const AnimationCube = ({ animationDelay }: { animationDelay: string }) => (
  <div
    className={`bg-tuna-shade float-left size-1/3 ${styles.animationCube}`}
    style={{ animationDelay }}
  />
);
